/**
 * startCaseSearch — s110 (TestFlight b77, mockup "Orella Doctors Start Case" S2): the start-a-case search box.
 * Case- and accent-insensitive "every word appears" match. PURE, no imports (scripts/check-start-case-sheet.mjs).
 */
export function fold(s) {
  return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
}

export function matchText(text, query) {
  const hay = fold(text)
  const words = fold(query).split(/\s+/).filter(Boolean)
  return words.length > 0 && words.every((w) => hay.includes(w))
}
